import script from "./Msg.vue?vue&type=script&setup=true&lang=js"
export * from "./Msg.vue?vue&type=script&setup=true&lang=js"

import "./Msg.vue?vue&type=style&index=0&id=48da26bc&lang=less"
import "./Msg.vue?vue&type=style&index=1&id=48da26bc&lang=less"

const __exports__ = script;

export default __exports__